import { useEffect, useState } from "react";

export const useElementVisibility = (elementId: string, options?: {margin?: string, threshold?: number}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const element = document.getElementById(elementId);
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: options?.threshold || 0.1, // Trigger when 10% visible
        rootMargin: options?.margin || '0px'
      }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [elementId, options?.margin, options?.threshold]);

  return isVisible;
};